RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.OverLandscapeSizeLimitModal = Marionette.ItemView.extend({
        events: {
            'click .x-trigger-intercom': 'showIntercom'
        },

        template: '#overLandscapeSizeLimitModalTemplate',

        serializeData: function () {
            const me = this;
            return _.extend(me.model.toJSON(), {
                companies: _.size(RivalIQ.state.landscape.get('companies'))
            });
        },

        templateHelpers: function () {
            return {
                formatLabel: RivalIQ.formatter.formatLabeledNumber
            };
        },

        showIntercom: function () {
            // Note: I'm not injecting this in the module call wrapping this function as window.Intercom isn't setup at
            // the time this view loads.
            if (window.Intercom) {
                window.Intercom('show');
            }
        }
    });

});
